import { inject, Injectable } from '@angular/core';
import Keycloak from 'keycloak-js';

@Injectable({
  providedIn: 'root'
})
export class PermisosService {
  private readonly keycloak = inject(Keycloak);

  get esAdmin(): boolean {
    return this.keycloak.hasRealmRole('admin');
  }

  get esDeposito(): boolean {
    return this.keycloak.hasRealmRole('deposito');
  }

  get esPlanta(): boolean {
    return this.keycloak.hasRealmRole('planta');
  }

  /** Sector propio del usuario. null = admin (ve y gestiona todo). */
  get sectorDelUsuario(): string | null {
    if (this.esAdmin) return null;
    if (this.esDeposito) return 'DEPOSITO_CENTRAL';
    if (this.esPlanta) return 'PLANTA';
    return null;
  }

  /** Retorna true si el usuario puede crear/editar/mover ítems en el sector dado. */
  puedeGestionar(sector: string | null | undefined): boolean {
    if (this.esAdmin) return true;
    if (this.esDeposito) return sector === 'DEPOSITO_CENTRAL';
    if (this.esPlanta) return sector === 'PLANTA';
    return false;
  }

  get puedeCrear(): boolean {
    return this.esAdmin || this.esDeposito || this.esPlanta;
  }

  get esOperario(): boolean {
    return this.keycloak.hasRealmRole('operario');
  }

  get puedeCrearOrdenRetiro(): boolean {
    return this.esAdmin || this.esOperario;
  }

  get puedeGestionarOrdenes(): boolean {
    return this.esAdmin || this.esDeposito || this.esPlanta;
  }
}
